/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum IHTTPAccept {
  ApplicationJsonCasecamelCase = 'application/json; case=camelCase',
  ApplicationJsonCasesnakeCase = 'application/json; case=snake_case',
  ApplicationJsonCaseAsIs = 'application/json; case=AsIs',
}
